// Safari browser detection utility
export const isSafari = () => {
  if (typeof window === 'undefined') return false;
  
  // Check for Safari user agent
  const userAgent = window.navigator.userAgent;
  const isSafariUA = /^((?!chrome|android).)*safari/i.test(userAgent);
  
  // Additional Safari-specific checks
  const isWebkit = 'WebkitAppearance' in document.documentElement.style;
  const isNotChrome = !window.chrome;
  const isNotEdge = !window.navigator.userAgent.includes('Edge');
  
  return isSafariUA && isWebkit && isNotChrome && isNotEdge;
};

// Alternative detection method using feature detection
export const isSafariFeatureDetection = () => {
  if (typeof window === 'undefined') return false;
  
  // Safari-specific feature detection
  const hasWebkitBackdropFilter = CSS.supports('-webkit-backdrop-filter', 'blur(1px)');
  const hasNotAppearance = !CSS.supports('appearance', 'none');
  
  return hasWebkitBackdropFilter && hasNotAppearance;
};

// Combined detection for maximum accuracy
export const detectSafari = () => {
  return isSafari() || isSafariFeatureDetection();
};